import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { class: "modal-card-head" }
const _hoisted_4 = {
  id: "confirmation-title",
  class: "modal-card-title"
}
const _hoisted_5 = {
  key: 0,
  class: "modal-card-body"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "modal-card-body"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "modal-card-foot" }

import { computed, ref } from 'vue';
import { useSanitize } from '@/shared/composables/useSanitize';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationModal',
  props: {
  confirmButtonLabel: {
    type: String,
    default: 'Yes',
  },
  cancelButtonLabel: {
    type: String,
    default: 'Cancel',
  },
  showCancelButton: {
    type: Boolean,
    default: true,
  },
  confirmationTitle: {
    type: String,
  },
  confirmationMessage: {
    type: String,
  },
  typeConfirmationValidationMessage: {
    type: String,
  },
},
  emits: ["confirm", "cancel"],
  setup(__props, { emit: __emit }) {

const { sanitize } = useSanitize();

const props = __props;

const confirmValue = ref('');

const title = computed(() => sanitize(props.confirmationTitle));
const message = computed(() => sanitize(props.confirmationMessage));
const buttonDisabled = computed(() => typedConfirmationRequired.value && !typedConfirmationValid.value);
const typedConfirmationRequired = computed(() => !!props.typeConfirmationValidationMessage);
const typedConfirmationValid = computed(() => props.typeConfirmationValidationMessage === confirmValue.value);

const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "modal-background" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(title.value), 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel'))),
          class: "delete",
          "aria-label": "close"
        })
      ]),
      (!typedConfirmationRequired.value)
        ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createElementVNode("span", {
              id: "confirmation-message",
              innerHTML: message.value
            }, null, 8, _hoisted_6)
          ]))
        : _createCommentVNode("", true),
      (typedConfirmationRequired.value)
        ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
            _createElementVNode("label", {
              class: "label",
              innerHTML: message.value
            }, null, 8, _hoisted_8),
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((confirmValue).value = $event))
            }, null, 512), [
              [_vModelText, confirmValue.value]
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("footer", _hoisted_9, [
        _createVNode(_component_n_button_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_button, {
              disabled: buttonDisabled.value,
              variant: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('confirm')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.confirmButtonLabel), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            (__props.showCancelButton)
              ? (_openBlock(), _createBlock(_component_n_button, {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('cancel'))),
                  variant: "primary--outline"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.cancelButtonLabel), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})